import { getInterval, getDefaultSportEventValues, getDefaultMatchPointConfigValues } from "../../utils";
import getDefaultAdminValues from "./default-admin-values";

export default ({ hasAdminPrivileges, isSportEvent }) => {
  const [startDate, endDate] = getInterval();
  return {
    title: "",
    description: "",
    startDate,
    endDate,
    keywords: [],
    liveStreams: [],
    contractId: undefined,
    graphicSetId: undefined,
    roomTemplateId: undefined,
    typeId: undefined,
    type: undefined,
    visible: false,
    billable: false,
    isInternalTest: false,
    localRecInfo: undefined,
    activeQod: false,
    isMutedOnStart: false,
    unmuteMinutesBefore: 5,

    ...getDefaultSportEventValues(isSportEvent),
    ...getDefaultMatchPointConfigValues(isSportEvent),
    ...getDefaultAdminValues(hasAdminPrivileges),
  };
};
